import { useState, useEffect } from 'react'
import { db } from '../firebase'

const CategoryTag = props => {

    const categoryId = props.category
    const [categoryName, setCategoryName] = useState('')

    useEffect(()=>{
        if (categoryId) {
            db.collection('categories').doc(categoryId).get()
              .then(snapshot=>{
                    const data = snapshot.data()
                    setCategoryName(data.name)
              })
        }
    },[categoryId])

    return (
        <>{categoryName}</>
    )
}

export default CategoryTag